/**
 *
 * Asynchronously loads the component for Mse005
 * Author: TruongTx
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
